import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "-");

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/audit-logs").then((r) => setLogs(r.data)).catch((e) => toast.error(e.friendlyMessage));
  }, []);

  return (
    <div className="animate-fade-in space-y-5" data-testid="audit-log-page">
      <div>
        <div className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Accountability</div>
        <h1 className="mt-1 font-heading text-3xl font-extrabold tracking-tight text-slate-900">Audit Log</h1>
        <p className="mt-1 text-sm text-slate-500">Every significant action - who did what, when, with old and new values.</p>
      </div>
      <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-slate-200 bg-slate-100/80 text-left text-xs uppercase tracking-wider text-slate-600">
                <th className="px-4 py-3 font-semibold">When</th>
                <th className="px-4 py-3 font-semibold">Actor</th>
                <th className="px-4 py-3 font-semibold">Action</th>
                <th className="px-4 py-3 font-semibold">Change</th>
                <th className="px-4 py-3 font-semibold">Detail</th>
              </tr>
            </thead>
            <tbody>
              {logs.length === 0 && (
                <tr><td colSpan={5} className="px-4 py-10 text-center text-slate-400">No audit entries yet.</td></tr>
              )}
              {logs.map((l) => (
                <tr key={l.id} data-testid={`audit-row-${l.id}`}
                  className={`border-b border-slate-100 transition-colors hover:bg-slate-50/80 ${l.task_id ? "cursor-pointer" : ""}`}
                  onClick={() => l.task_id && navigate(`/tasks/${l.task_id}`)}>
                  <td className="whitespace-nowrap px-4 py-2.5 font-data text-xs text-slate-500">{fmt(l.created_at)}</td>
                  <td className="px-4 py-2.5 font-semibold text-slate-800">{l.actor_name}</td>
                  <td className="px-4 py-2.5">
                    <span className="rounded-md bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-700">{l.action}</span>
                  </td>
                  <td className="px-4 py-2.5 font-data text-xs text-slate-600">
                    {l.old_value != null && l.new_value != null ? `${l.old_value} → ${l.new_value}` : "-"}
                  </td>
                  <td className="max-w-xs truncate px-4 py-2.5 text-slate-500">{l.detail || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
